"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultExtractor = void 0;
var defaultExtractor = function (response) { return response; };
exports.defaultExtractor = defaultExtractor;
//# sourceMappingURL=Tag.consts.js.map